// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.token-cards-section {
    margin-bottom: 32px;
    padding: 0 20px;
}

.token-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    max-width: 1400px;
    margin: 0 auto;
}

.token-card-wrapper {
    position: relative;
    min-height: 200px;
    border-radius: 0;
}

.remove-token-button {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: var(--text-color);
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.remove-token-button:hover {
    opacity: 1;
}

.add-card-container {
    position: relative;
    min-height: 200px;
}

.add-card-button {
    width: 100%;
    height: 100%;
    min-height: 200px;
    border: 2px dashed black;
    background: none;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: black;
    transition: all 0.2s ease;
}

.add-card-button:hover {
    border-color: var(--primary-color);
    color: var(--primary-color);
}

/* Token Selector Styles */
.token-selector {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-color: var(--card-background-color);
    border: 1px solid black;
    padding: 16px;
    z-index: 10;
}

.token-selector-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.token-selector-header h3 {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-color);
}

.close-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: var(--text-color);
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.close-button:hover {
    opacity: 1;
}

.search-container_card {
    margin-bottom: 16px;
}

.search-input_card {
    width: 90%;
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    font-family: var(--app-font-family);
    font-size: 14px;
}

.search-input:focus {
    outline: none;
    border-color: var(--primary-color);
}

.token-list {
    max-height: 300px;
    overflow-y: auto;
}

.token-list-item {
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.token-list-item:hover {
    background-color: var(--hover-background);
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .token-cards-grid {
        grid-template-columns: 1fr;
    }

    .token-cards-section {
        padding: 0 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/tokenCardSection.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,8CAA8C;IAC9C,uBAAuB;IACvB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,2BAA2B;AAC3B;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".token-cards-section {\n    margin-bottom: 32px;\n    padding: 0 20px;\n}\n\n.token-cards-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n.token-card-wrapper {\n    position: relative;\n    min-height: 200px;\n    border-radius: 0;\n}\n\n.remove-token-button {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 2;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    color: var(--text-color);\n    opacity: 0.6;\n    transition: opacity 0.2s ease;\n}\n\n.remove-token-button:hover {\n    opacity: 1;\n}\n\n.add-card-container {\n    position: relative;\n    min-height: 200px;\n}\n\n.add-card-button {\n    width: 100%;\n    height: 100%;\n    min-height: 200px;\n    border: 2px dashed black;\n    background: none;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    color: black;\n    transition: all 0.2s ease;\n}\n\n.add-card-button:hover {\n    border-color: var(--primary-color);\n    color: var(--primary-color);\n}\n\n/* Token Selector Styles */\n.token-selector {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    background-color: var(--card-background-color);\n    border: 1px solid black;\n    padding: 16px;\n    z-index: 10;\n}\n\n.token-selector-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.token-selector-header h3 {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--text-color);\n}\n\n.close-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    color: var(--text-color);\n    opacity: 0.6;\n    transition: opacity 0.2s ease;\n}\n\n.close-button:hover {\n    opacity: 1;\n}\n\n.search-container_card {\n    margin-bottom: 16px;\n}\n\n.search-input_card {\n    width: 90%;\n    padding: 8px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    font-family: var(--app-font-family);\n    font-size: 14px;\n}\n\n.search-input:focus {\n    outline: none;\n    border-color: var(--primary-color);\n}\n\n.token-list {\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.token-list-item {\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.token-list-item:hover {\n    background-color: var(--hover-background);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .token-cards-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .token-cards-section {\n        padding: 0 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
